var t = "_icon_1q1xv_1",
  o = "_text_2k46m_3",
  n = "_textp_2k46m_1",
  i = "_description_2k46m_13 _text_2k46m_3",
  e = "_tooltip_2k46m_18",
  _ = "_tooltipAbsolute_2k46m_55",
  c = "_innerTextContainer_2k46m_59",
  s = "_iconContainer_2k46m_65",
  r = "_iconContainerDisabled_2k46m_73",
  a = {
    icon: t,
    text: o,
    textp: n,
    description: i,
    tooltip: e,
    tooltipAbsolute: _,
    innerTextContainer: c,
    iconContainer: s,
    iconContainerDisabled: r
  };
export { a as default, i as description, t as icon, s as iconContainer, r as iconContainerDisabled, c as innerTextContainer, o as text, n as textp, e as tooltip, _ as tooltipAbsolute };